"use client";

import { usePathname } from "next/navigation";

import { chromeLocaleForPath } from "@/lib/chrome-locale";
import { CHROME_UI_COPY } from "@/lib/chrome-ui-copy";

/**
 * The skip link's text, in the page's language. The root layout serves every
 * locale and keeps the anchor itself (the landmark and Google SEO checks read
 * it there); only the label is picked from the path, as SiteHeaderBar does,
 * during SSR as well, so /hi/ pages never ship the English label.
 */
export default function SkipToContentLabel() {
  return <>{CHROME_UI_COPY[chromeLocaleForPath(usePathname())].skipToContent}</>;
}
